import { useKrCardContext } from '@/common/card/KrCardContext';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { IconUtils } from '@/common/utils/IconUtils';
import { StringUtils } from '@/common/utils/StringUtils';
import { useMemo } from 'react';
import { Title } from '../../title/Title';
import { useTab } from '../entityTabs/TabContext';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';
import { Mode } from '../enumerations/Mode';

export const EntityTitle = ({ buttons }) => {
  const { entityDef, hist, entityObj, entityFormMode, breadcrumbs } = useEntityMgr();
  const { mode } = useNavState();

  const { tabId } = useTab();
  const inDialog = useInDialog();
  const inKrCard = Boolean(useKrCardContext());

  let icon = useMemo(() => IconUtils.iconFromIconStr(entityDef.icon), [entityDef.icon]);

  let displayName = mode === Mode.DETAIL ? StringUtils.toSingular(entityDef.displayName) : entityDef.displayName;
  let title = displayName + (hist ? ' History' : '');
  let subHeader = null;

  if (entityFormMode === EntityFormMode.ADD) {
    subHeader = title;
    title = 'New ' + title;
  } else if (entityObj != null && Object.keys(entityObj).length !== 0) {
    subHeader = title;
    title = entityObj.name === 'NO_NAME' ? StringUtils.toCodeConvention(displayName) : entityObj.name;
  }

  if (inDialog || inKrCard) return;

  return (
    <Title
      icon={!tabId && icon}
      title={!tabId && title}
      subHeader={!tabId && subHeader}
      breadcrumbs={!tabId && breadcrumbs}
      buttons={buttons}
    />
  );
};
